"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireReactElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
/** A function that throws an error when a value isn't a valid React Element, otherwise returns the value */
const requireReactElement = (children) => {
    const isReactElement = React.isValidElement(children);
    if (!isReactElement) {
        throw Error(`Expected a single React Element child, but got: ${React.Children.toArray(children)
            .map((child) => typeof child === 'object' && 'type' in child && typeof child.type === 'string'
            ? child.type
            : typeof child)
            .join(', ')}`);
    }
    return children;
};
exports.requireReactElement = requireReactElement;
//# sourceMappingURL=require-react-element.js.map